import airtimeSessions from '../images/NP/486697282_10230542201722041_5709619117578699741_n.jpg'
import bullMoose from '../images/NP/billy.png'
import soberAlbum from '../images/NP/don1.png'
import jacobSolo from '../images/NP/randy11.jpg'

const sliderData = [
  {
    title: 'Don Story',
    image: soberAlbum,
    id: '1',
    year: 'Aug 2021',
    link: 'https://jacksongrimm.bandcamp.com/album/sober-again',
    description: 'Don Story',
  },
  {
    title: 'Billy Gee',
    image: bullMoose,
    id: '12',
    year: 'Nov 2018',
    link: 'https://jacksongrimm.bandcamp.com/album/the-bull-moose-party',
    description: 'Billy Gee',
  },
  {
    title: 'Mel Jones',
    image: airtimeSessions,
    id: '3',
    year: 'Jan 2016',
    link: 'https://jacksongrimm.bandcamp.com/album/the-airtime-sessions',
    description: 'Mel Jones',
  },
  {
    title: 'Randy Gambill',
    image: jacobSolo,
    id: '4',
    year: 'Jan 2016',
    link: 'https://jacksongrimm.bandcamp.com/album/the-airtime-sessions',
    description: 'Randy Gambill',
  },
]

export default sliderData
